import { Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type UserInfo } from "../../LoginPage/types/auth.types.ts"
import {
  DashboardHeaderSearch,
  type DashboardTableFilterKey
} from "./DashboardHeaderSearch.tsx"

const { Title, Text } = Typography

interface DashboardHeaderProps {
  user: UserInfo | null
  canSearch: boolean
  canCreate: boolean
  tableFilterKey: DashboardTableFilterKey | null
}

export function DashboardHeader({
  user,
  canCreate,
  canSearch,
  tableFilterKey
}: DashboardHeaderProps) {
  const { t } = useTranslation()
  const name = user?.first_name

  return (
    <Flex vertical gap={16}>
      <Flex
        gap={"small"}
        className={"max-lg:flex-col max-lg:items-start"}
        justify="space-between"
        align="center"
      >
        <div>
          <Title level={2} className="m-0 text-start">
            {name
              ? t("dashboard.greeting", "Welcome, {{name}}!", { name })
              : t("dashboard.greetingNoName", "Welcome!")}
          </Title>
          <Text type="secondary">
            {t(
              "dashboard.subtitle",
              "Here's a snapshot of what's happening today."
            )}
          </Text>
        </div>

        {(canSearch || canCreate) && tableFilterKey && (
          <DashboardHeaderSearch
            canCreate={canCreate}
            tableFilterKey={tableFilterKey}
          />
        )}
      </Flex>
    </Flex>
  )
}
